import BaseAPIService from './BaseAPIService';
import axios from 'axios';

export default class MomentService extends BaseAPIService {
	constructor() {
		super();
	}

	async prefetchMoments() {
		const query = require('../graphql/queries/prefetchMoments.gql');
		const result = await this.query({ query });
		return result.data.prefetchMoments;
	}

	async getManagableMoments(limit, page, filters) {
		const { sortAscending, sortBy, search, tags } = filters;

		const query = require('../graphql/queries/managableMoments.gql');
		const variables = { limit, page, sortAscending, search, sortBy, tags };
		const result = await this.query({ query, variables });
		return result.data.managableMoments;
	}

	async uploadSingleMoment(file) {
		if (!file) throw new Error("File shouldn't be empty");

		const mutation = require('../graphql/mutations/uploadSingleMoment.gql');
		const variables = { file };
		const result = await this.mutate({ mutation, variables });
		return result.data.uploadSingleMoment;
	}

	async createMoment(moment) {
		if (!moment) throw new Error("moment argument shouldn't be empty");

		const { content, active, published, featured, experienceIds } = moment;

		const mutation = require('../graphql/mutations/createMoment.gql');
		const variables = {
			moment,
		};
		const result = await this.mutate({ mutation, variables });
		return result.data.updateMoment;
	}

	async updateMoment(moment) {
		if (!moment) throw new Error("moment argument shouldn't be empty");

		const { id, content, active, published, featured, experienceIds } = moment;

		const mutation = require('../graphql/mutations/updateMoment.gql');
		const variables = {
			id,
			moment: {
				content,
				active,
				published,
				featured,
				experienceIds,
			},
		};
		const result = await this.mutate({ mutation, variables });
		return result.data.updateMoment;
	}

	async deleteMoment(id) {
		if (!id) throw new Error("id argument shouldn't be empty");

		const mutation = require('../graphql/mutations/deleteMoment.gql');
		const variables = {
			id,
		};
		const result = await this.mutate({ mutation, variables });
		return result.data.deleteMoment;
	}

	async batchUpdateMomentStatus(ids, status = 'pending') {
		if (!ids) throw new Error("ids argument shouldn't be empty");

		const mutation = require('../graphql/mutations/batchUpdateMomentStatus.gql');
		const variables = {
			ids,
			status,
		};
		const result = await this.mutate({ mutation, variables });
		return result.data.batchUpdateMomentStatus;
	}

	async getAvailableHashtags() {
		const query = require('../graphql/queries/availableHashtags.gql');
		const result = await this.query({ query });
		return result.data.availableHashtags;
	}

	async fetchSocialPosts(tags) {
		const result = {};
		result.instagram = await this.fetchInstagramPosts(tags);
		return result;
	}

	async fetchInstagramPosts(tags, maxId) {
		const collections = [];
		for (let tag of tags) {
			collections.push(await this.fetchInstagramByTag(tag));
		}
		return collections;
	}

	async fetchInstagramByTag(tag, maxId) {
		const url = `https://www.instagram.com/explore/tags/${tag.replace('#', '')}?__a=1`;
		const res = await axios.get(url);
		const {
			graphql: {
				hashtag: { edge_hashtag_to_media: results },
			},
		} = res.data;
		const {
			page_info: { end_cursor: next, has_next_page: hasNext },
			edges: socialPosts,
		} = results;

		const posts = socialPosts.map((it) => {
			const node = it.node;
			let obj = {
				active: true,
				published: false,
				author: {
					id: node.owner.id,
				},
			};
			obj.postCreated = new Date(node.taken_at_timestamp * 1000);
			obj.mediaType = node.is_video === true ? 'video' : 'image';
			obj.media = {
				url: node.display_url,
				width: node.dimensions.width,
				height: node.dimensions.height,
			};
			if (node.id) {
				obj.postId = node.id;
			}
			if (node.shortcode) {
				obj.link = `https://www.instagram.com/p/${node.shortcode}`;
			}
			if (node.shortcode) {
				obj.link = `https://www.instagram.com/p/${node.shortcode}`;
			}
			if (
				node.edge_media_to_caption &&
				node.edge_media_to_caption.edges &&
				node.edge_media_to_caption.edges.length > 0
			) {
				obj.content = node.edge_media_to_caption.edges[0].node.text;
			}
			if (node.thumbnail_resources && node.thumbnail_resources.length > 0) {
				const thumbnail = node.thumbnail_resources[node.thumbnail_resources.length - 1];
				obj.thumbnail = {
					url: thumbnail.src,
					width: thumbnail.config_width,
					height: thumbnail.config_height,
				};
			} else {
				obj.thumbnail = {
					url: node.display_url,
					width: node.dimensions.width,
					height: node.dimensions.height,
				};
			}
			return obj;
		});

		return {
			tag,
			posts,
			next,
			hasNext,
		};
	}
}
